export type CategoryType = "technical_support_connectivity" | "billing_account_inquiries" | "getting_started" | "product_ordering_activation" | "prop_trading_challenge" | "trading_psychology_discipline" | "suggestions_complaints_feedback" | "contact_neon_partnerships";
export type PriorityType = "low" | "medium" | "high";
export type StatusType = "pending_user" | "pending_admin" | "in_progress" | "closed";

export const CategoryList = [
  "technical_support_connectivity",
  "billing_account_inquiries",
  "getting_started",
  "product_ordering_activation",
  "prop_trading_challenge",
  "trading_psychology_discipline",
  "suggestions_complaints_feedback",
  "contact_neon_partnerships",
] as const satisfies readonly CategoryType[];
export const PriorityList = ["low", "medium", "high"] as const satisfies readonly PriorityType[];

export interface TicketApiModel {
    id: number;
    subject: string;
    status: StatusType;
    category: CategoryType;
    priority: PriorityType;
    is_seen?: boolean;
    is_answered?: boolean;
    has_new_message?: boolean;
    unseen_messages_count?: number;
    user: {
        admin: null|{
            permissions: {
                change_settings: boolean;
                change_user_settings: boolean;
                manage_admins: boolean;
                ticket_access: boolean;
            },
            promoted_at: number;
            promoter: {
                first_name: string;
                id: number;
                last_name: string;
                username: string;
            }
        };
        id: number;
        first_name: string;
        last_name: string;
        username: string;
    };
    created_at: number;
    updated_at: number;
    closed_at: number|null;
}

export interface TicketInfoApiModel {
    ticket: TicketApiModel;
    messages: {
        id: number;
        message: string;
        is_admin: boolean;
        sent_at: number;
        is_seen?: boolean;
        seen_at?: number | null;
        is_answered?: boolean;
        answered_at?: number | null;
        is_new?: boolean;
        media: {
            path: string;
            content_type: string;
            file_name: string;
            file_size: number;
        }[]
    }[];
}

export function getTicketSeenState(ticket: TicketApiModel): "new" | "answered" | "seen" | null {
    if (ticket.has_new_message || (ticket.unseen_messages_count ?? 0) > 0) {
        return "new";
    }
    if (ticket.is_answered) {
        return "answered";
    }
    if (ticket.is_seen) {
        return "seen";
    }
    return null;
}

export function getMessageState(message: TicketInfoApiModel["messages"][number]): "new" | "answered" | "seen" | null {
    if (message.is_new) return "new";
    if (message.is_answered) return "answered";
    if (message.is_seen) return "seen";
    return null;
}

export function getCategoryLable(category: CategoryType): string{
    switch (category){
        case "technical_support_connectivity":
            return "پشتیبانی فنی و اتصال";
        case "billing_account_inquiries":
            return "پرسش‌های مالی و حساب کاربری";
        case "getting_started":
            return "از کجا شروع کنم؟";
        case "product_ordering_activation":
            return "سفارش و فعال‌سازی محصول";
        case "prop_trading_challenge":
            return "پراپ تریدینگ و عبور از چالش";
        case "trading_psychology_discipline":
            return "روانشناسی ترید و نظم ذهنی";
        case "suggestions_complaints_feedback":
            return "پیشنهادات، شکایات یا بازخوردها";
        case "contact_neon_partnerships":
            return "ارتباط با تیم NEON / همکاری‌ها";
    }
}

export function getStatusLable(status: StatusType): string{
    switch (status){
        case "pending_user":
            return "در انتظار کاربر";
        case "pending_admin":
            return "در انتظار پشتیبانی";
        case "in_progress":
            return "در حال بررسی";
        case "closed":
            return "بسته شده";
    }
}

export function getPriorityLable(priority: PriorityType): string{
    switch (priority){
        case "low":
            return "کم";
        case "medium":
            return "متوسط";
        case "high":
            return "زیاد";
    }
}
